import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categoryArray: [], // Store API response here
  },
  reducers: {
    setcategory(state, action) {
      state.categoryArray = action.payload; // Update state correctly
    },
  },
});

export const { setcategory } = categorySlice.actions;
export default categorySlice.reducer;
